var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill: #D1D1D1;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M914.4,339.5L668.2,93.2c-3.3-3.3-7.8-5.1-12.4-5.1l-22.4,0.2c-0.7-0.1-1.5-0.2-2.2-0.2c-0.8,0-1.7,0.1-2.5,0.2 l-455.7,3.3c-9.5,0.1-17.2,7.8-17.2,17.3v861.8c0,9.6,7.8,17.3,17.3,17.3h729.2c9.6,0,17.3-7.8,17.3-17.3v-619 C919.5,347.1,917.7,342.7,914.4,339.5z M884.3,358.4H648.4V122.8l0.3,0L884.3,358.4z M190.4,953.4V126.1l423.4-3v252.7 c0,9.6,7.8,17.3,17.3,17.3h253.7v560.3H190.4z M751.9,593.9c0,7.2-5.8,13-13,13H336.4c-7.2,0-13-5.8-13-13s5.8-13,13-13h402.5 C746.1,580.9,751.9,586.8,751.9,593.9z M751.9,716.7c0,7.2-5.8,13-13,13H336.4c-7.2,0-13-5.8-13-13s5.8-13,13-13h402.5 C746.1,703.7,751.9,709.6,751.9,716.7z M751.9,839.6c0,7.2-5.8,13-13,13H336.4c-7.2,0-13-5.8-13-13c0-7.2,5.8-13,13-13h402.5 C746.1,826.6,751.9,832.4,751.9,839.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.42e16c39a428aff635fe0d730a437816.svg";
export { ForwardRef as ReactComponent };